import './index.less'

export default class OldInviteNewFaq {
  constructor() {
    this.titleDOM = document.querySelector('[data-old-invite-new-faq-title]')
    this.faqLabels = document.querySelectorAll('[data-old-invite-new-faq-label]')

    if (this.titleDOM && this.faqLabels) {
      this.init()
    }

    const faqDOM = document.querySelector('[data-old-invite-new-faq]')
    if (faqDOM) {
      this.observe(faqDOM)
    }
  }
  init() {
    this.faqLabels.forEach(item => {
      item.onclick = (e) => {
        const target = e.target.tagName === 'H4' ? e.target.parentElement : e.target
        const previousElement = target.previousElementSibling

        // 展开才记录
        if (!previousElement.checked) {
          // 数据埋码
          this.GAEvent({
            module: this.titleDOM.innerText || 'FAQ',
            position: target.querySelector('h4').innerText,
            status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
          })
        }
      }
    })
  }

  // 数据埋码
  GAEvent(params) {
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event":"ga4Event",
      "event_name":"refer_new_user_clicks",
      "event_parameters":{
        "current_page": window.location.href, // current page url
        ...params
      }
    })
  }

  // 出场动画
  observe(sectionDOM) {
    const Observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active')
        }
      })
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.2,
    })

    const targetDOMs = sectionDOM?.querySelectorAll('[data-animation-dom]')
    if (targetDOMs.length > 0) {
      targetDOMs.forEach(it => Observer.observe(it))
    }
  }
}